import { render, staticRenderFns } from "./ImagePosition.vue?vue&type=template&id=1b50d519&scoped=true&"
import script from "./ImagePosition.vue?vue&type=script&lang=js&"
export * from "./ImagePosition.vue?vue&type=script&lang=js&"
import style0 from "./ImagePosition.vue?vue&type=style&index=0&id=1b50d519&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b50d519",
  null
  
)

export default component.exports